import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DataService } from '../../../services/data/data.service';
import { messages } from '../../funciones/mensajes';
import Swal from 'sweetalert2';
import { Actividades, Areas, Filosofia_Corporativa, Metas, Objetivos, obtenerLogo, Perspectiva, Perspectivas, Planificacion, Responsables, Unidad_Medida } from '../../../models/Formulacion/indicadores-metas/datos';
import { ReportesService } from '../../../services/avance-seguimiento/reportes/reportes.service';
import html2canvas from 'html2canvas';
import pdfMake from 'pdfmake/build/pdfmake';
import { ConstantesImagenes } from '../../../../assets/img/codigoimagenes';
import { CookieService } from 'ngx-cookie-service';
import { firstValueFrom } from 'rxjs';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { PlanificacionService } from '../../../services/gestion/planificacion/planificacion.service';
import { PerspectivaService } from '../../../services/gestion/perspectivas/perspectiva.service';
import { ObjetivoService } from '../../../services/gestion/objetivo/objetivo.service';
import { ResponsableService } from '../../../services/gestion/responsable/responsable.service';
import { FilosofiaService } from '../../../services/gestion/filosofia/filosofia.service';
import { MatrizService } from '../../../services/gestion/matriz/matriz.service';
import { IndicadorService } from '../../../services/gestion/indicadores/indicador.service';
import { ProyectosService } from '../../../services/gestion/proyectos/proyectos.service';
import { StrategiaService } from '../../../services/gestion/strategias/strategia.service';

@Component({
  selector: 'app-plan-estrategico',
  templateUrl: './plan-estrategico.component.html',
  styleUrl: './plan-estrategico.component.css'
})
export class PlanEstrategicoComponent implements OnInit {
  @ViewChild('txtIntroduccion') txtIntroduccion!: ElementRef<HTMLInputElement>;

  private planeacionId: any;
  isDownloadingPdf = false;
  reporteGeneradoExitosamente: boolean;
  public perspectivas: Perspectivas[] = [];
  public diccionarioPerspectivas: any = [];
  public planeacion = [];
  private planeacionFoda: any;
  public perspectiva: Perspectivas[] = [];
  public concepto: Filosofia_Corporativa[] = [];
  public diccionarioFLOA1: any = [];
  public diccionarioFLOA2: any = [];
  public diccionarioFLOA1V2: any = [];
  public diccionarioFLOA2V2: any = [];
  elemento = [];
  planeacionObj: Planificacion[] = [];
  responsable: Responsables[] = [];
  public perspectivaObj: Perspectivas[] = [];
  public objetivos: Objetivos[] = [];
  public Oobjetivos: any = [];
  nombreInstitucion = { nombre: '', acronimo: '' };
  private verCodigo = false;

  public internos = [
    { id: 1, type: 'FORTALEZA', elemento: 'Fortalezas' },
    { id: 2, type: 'DEBILIDAD', elemento: 'Debilidades' },
  ];
  public externos = [
    { id: 3, type: 'OPORTUNIDAD', elemento: 'Oportunidades' },
    { id: 4, type: 'AMENAZA', elemento: 'Amenazas' },
  ];

  imprimirIntro: boolean = true;
  imprimirMetodologia: boolean = true;
  imprimirFilosofia: boolean = true;
  imprimirFoda: boolean = true;
  imprimirFodaV2: boolean = true;
  imprimirObjetivos: boolean = true;
  imprimirIndicadores: boolean = true;
  imprimirCmi: boolean = true;
  imprimirPlanOperativo: boolean = true;

  imgLogo = ''
  companyId = ''
  imgCmi: any;
  imgFloa: any;


  verFodaV1 = false;
  verFodaV2 = false;

  public aniosDisponibles = [
    { name: '2022', check: true },
    { name: '2023', check: false },
  ];
  minDate = moment(new Date(2023, 1, 1)).toDate();
  maxDate = moment(new Date(2023, 11, 31)).toDate();
  public areas: Areas[] = [];
  public perspectivasIndMet: Perspectivas[] = [];
  public objetivosIndMet: Objetivos[] = [];
  public unidades_med: Unidad_Medida[] = [];
  indicadoresIndMet: any[] = [];
  public metas: Metas[] = [];
  aniosDisponiblesPE = [];
  minDatePE = moment(new Date(2022, 0, 1)).toDate();
  maxDatePE = moment(new Date(2022, 11, 31)).toDate();
  responsablesPE = [];
  public responsables: Responsables[] = [];
  public responsablesAct: Responsables[] = [];
  perspectivasPE: Perspectiva[] = [];
  objetivosPE: Objetivos[] = [];
  proyectos: any[] = [];
  public actividades: Actividades[] = [];
  public estrategias: any[] = [];


  //DATOS
  dataPlanificacion: any;
  dataPerspectivas: any;
  dataObjetivos: any;
  dataResponsables: any;
  dataActivities: any;
  dataEstrategias: any;
  dataIndicadores: any;

  constructor(
    public dataService: DataService,
    private altaplanificacionesService: PlanificacionService,
    private perspectivaService: PerspectivaService,
    private objetivoService: ObjetivoService,
    private responsableService: ResponsableService,
    private filosofiaService: FilosofiaService,
    private reportesService: ReportesService,
    private matrizService: MatrizService,
    private indicadoresService: IndicadorService,
    private estrategiaService: StrategiaService,
    private proyectosService: ProyectosService,
    private translateService: TranslateService,
    private cookies: CookieService,
  ) {
    this.isDownloadingPdf = true;
    if (dataService.modules.includes('ale-matrizfoda')) {
      this.verFodaV1 = true;
    } else {
      this.imprimirFoda = false;
    }
    if (dataService.modules.includes('ale-matrizderiesgosyoportunidades')) {
      this.verFodaV2 = true;
    } else {
      this.imprimirFodaV2 = false;
    }
    //@ts-ignore
    this.planeacionId = Number(this.cookies.get('idInstitucion'));

    //mtodo async 
    this.obtenerIntroduccionDelPlan();
  }

  ngOnInit(): void {

  }

  private async obtenerIntroduccionDelPlan(): Promise<void> {
    try {
      const planData = await firstValueFrom(
        this.altaplanificacionesService.getPlanificacionById(this.planeacionId.toString())
      ) as any;
      this.dataPlanificacion = planData;
      if (planData?.report_intro) {
        setTimeout(() => {
          const elemento = document.getElementById('txt_introduccion') as HTMLInputElement;
          if (elemento) {
            elemento.value = planData.report_intro;
          }
        }, 100);
      }
      this.cargarTodosLosDatos();
    } catch (error) {
    }
  }

  private async cargarTodosLosDatos(): Promise<void> {
    try {
      await Promise.allSettled([
        await this.obtData(),
        this.obtDataFilo(),
        this.obtDataFoda(),
        await this.obtDataObjetivos(),
        this.obtDataIndicadoresMetas()
      ]);
    } catch (error) {
    } finally {
      this.isDownloadingPdf = false;
    }
  }

  //OBTENCION DE DATOS
  private async obtData(): Promise<void> {
    try {

      this.dataPerspectivas = this.dataPlanificacion.perspectives;
      this.perspectivas = [];
      for (const per of this.dataPerspectivas) {
        if (Number(per.planningId) === this.planeacionId) {
          this.perspectivas.push({
            nombre: per.name,
            descripcion: per.descripcion,
            planningId: per.planningId,
            id: per.id,
            check: true,
          });
        }
      }

      this.perspectivas = this.ordenamientoPer(this.perspectivas);
      this.perspectivas.forEach((per) => {
        this.diccionarioPerspectivas.push({ perspectiva: per, objetivos: [] });
      });

      this.dataObjetivos = [];

      // Procesar perspectivas en lotes de 10
      for (let i = 0; i < this.diccionarioPerspectivas.length; i += 10) {
        const batch = this.diccionarioPerspectivas.slice(i, i + 10);
        await Promise.all(batch.map(async (per: any) => {
          const objs: any[] = await this.objetivoService.getObjectivesByPerspectiveGQL(per.perspectiva.id);
          if (!objs || objs.length === 0) return;
          this.dataObjetivos = [...this.dataObjetivos, ...objs];
          objs.forEach((obj: any) => {
            per.objetivos.push({
              nombre: obj.name,
              descripcion: obj.description,
              ponderacion: obj.weighing,
              perspectiveId: obj.perspectiveId ?? obj.perspective?.id ?? per.perspectiva.id,
              id: obj.id,
            });
          });
          per.objetivos = this.ordenarPerspe(per.objetivos);
        }));
      }
    } catch (error) {
    }
  }

  private async configurarDatosPlan(plan: any): Promise<void> {
    if (plan.institution.acronym === 'IDemo' || plan.institution.acronym === 'Bienestar') {
      //this.verCodigo = true;
    }
    this.companyId = plan.institution.code;
    this.nombreInstitucion = {
      nombre: plan.institution.name,
      acronimo: plan.institution.acronym
    };
    await this.obtenerLogo();
  }

  private async obtDataFilo(): Promise<void> {
    try {
      if (this.dataPlanificacion.philosophies && this.dataPlanificacion.philosophies.length) {
        await this.configurarDatosPlan(this.dataPlanificacion);
        this.concepto = [];
        for (const fil of this.dataPlanificacion.philosophies) {
          this.concepto.push({
            name: fil.name,
            description: fil.description,
            planningId: this.planeacionId,
            id: fil.id,
          });
        }
        this.concepto = this.ordenarConceptos(this.concepto);
      } else {
        // Fallback al API viejo
        const filosofiaResponse = await firstValueFrom(this.filosofiaService.getFilosofia());
        await this.obtFilosofia(filosofiaResponse);
      }
    } catch (error) {
    }
  }

  private async obtFilosofia(response: any): Promise<void> {
    this.concepto = [];
    for (const per of response) {
      if (Number(per.planning.id) === this.planeacionId) {
        this.concepto.push({
          name: per.name,
          description: per.description,
          planningId: per.planning.id,
          id: per.id,
        });
      }
    }

    if (this.concepto.length === 0) {
      await this.crearFilosofiaporDefecto();
    }

    this.concepto = this.ordenarConceptos(this.concepto);
  }

  private async crearFilosofiaporDefecto(): Promise<void> {
    const conceptos = [
      { name: 'Misión', description: 'Misión' },
      { name: 'Visión', description: 'Visión' },
      { name: 'Principios', description: 'Principios' }
    ];

    try {
      for (const concepto of conceptos) {
        const nuevoConcepto = new Filosofia_Corporativa();
        nuevoConcepto.planningId = this.planeacionId;
        nuevoConcepto.name = concepto.name;
        nuevoConcepto.description = concepto.description;

        await firstValueFrom(this.filosofiaService.postfilosofia(nuevoConcepto));
      }

      // Recargar filosofía después de crear los conceptos por defecto
      const planData = await firstValueFrom(
        this.altaplanificacionesService.getPlanificacionById(this.planeacionId.toString())
      ) as any;
      this.dataPlanificacion = planData;

      this.concepto = [];
      for (const fil of this.dataPlanificacion.philosophies) {
        this.concepto.push({
          name: fil.name,
          description: fil.description,
          planningId: this.planeacionId,
          id: fil.id,
        });
      }
      this.concepto = this.ordenarConceptos(this.concepto);
    } catch (error) {
    }

  }

  private async obtDataFoda(): Promise<void> {
    try {
      const respuesta = this.dataPlanificacion;
      this.planeacionFoda = {
        id: respuesta.id,
        nombre: respuesta.name,
        fecha_inicio: moment(respuesta.initial_date).toDate(),
        fecha_fin: moment(respuesta.end_date).toDate(),
        institucionId: respuesta.institution.id,
        isActive: respuesta.isActive
      };
      this.procesarPerspectivasFoda(respuesta.perspectives);
      this.inicializarDiccionariosFoda();

      const res = await firstValueFrom(this.matrizService.getFLOA());
      this.getFloaV1(res);
      this.getFloaV2(res);
    } catch (error) {
    }
  }

  private procesarPerspectivasFoda(perspectivas: any[]): void {
    this.perspectiva = [];
    for (const per of perspectivas) {
      this.perspectiva.push({
        nombre: per.name,
        descripcion: per.description,
        planningId: this.planeacionId,
        id: per.id,
      });
    }
    this.perspectiva = this.ordenarPerspe(this.perspectiva);
  }

  private inicializarDiccionariosFoda(): void {
    this.diccionarioFLOA1 = [];
    this.diccionarioFLOA2 = [];
    this.diccionarioFLOA1V2 = [];
    this.diccionarioFLOA2V2 = [];

    this.internos.forEach(per => {
      this.diccionarioFLOA1.push({
        internosss: per,
        elementooo: [],
        perspectivaaa: this.perspectiva
      });
      this.diccionarioFLOA1V2.push({
        internosss: per,
        elementooo: [],
        perspectivaaa: this.perspectiva
      });
    });

    this.externos.forEach(per1 => {
      this.diccionarioFLOA2.push({
        externosss: per1,
        elementooo: [],
        perspectivaaa: this.perspectiva
      });
      this.diccionarioFLOA2V2.push({
        externosss: per1,
        elementooo: [],
        perspectivaaa: this.perspectiva
      });
    });
  }

  private async obtDataObjetivos(): Promise<void> {
    try {
      const response = this.dataPlanificacion;
      await this.procesarPlanificacionesObjetivos(response);

      const perspectivasResponse = response.perspectives;
      this.procesarPerspectivasObjetivos(perspectivasResponse);

      const objetivosResponse = this.dataObjetivos;
      this.obtObjetivos(objetivosResponse);
    } catch (error) {
    }
  }

  private async procesarPlanificacionesObjetivos(plan: any): Promise<void> {
    if (this.planeacionId === Number(plan.id)) {
      this.planeacionObj.push({
        id: plan.id,
        nombre: plan.name,
        fecha_inicio: moment(plan.initial_date).toDate(),
        fecha_fin: moment(plan.end_date).toDate(),
        institucionId: plan.institution.id,
        isActive: plan.isActive,
      });
      await this.obtenerResponsables(plan.institutionId);
    }
  }

  private async obtenerResponsables(institutionId: number): Promise<void> {
    try {
      const responsableResponse = await firstValueFrom(this.responsableService.getResponsable());
      this.responsable = [];

      for (const are of responsableResponse) {
        if (are.institution.id === institutionId) {
          for (const resp of are.responsibles) {
            this.responsable.push({
              id: resp.id,
              nombre: resp.name,
              cargo: resp.position,
              responsibles: [resp],
            });
          }
        }
      }
      this.responsable = this.ordenarPerspe(this.responsable);
      this.dataResponsables = this.responsable;
    } catch (error) {
    }
  }

  private procesarPerspectivasObjetivos(per: any): void {
    this.perspectivaObj = [];
    for (const pers of per) {
      if (Number(pers.planningId) === this.planeacionId) {
        this.perspectivaObj.push({
          nombre: pers.name,
          descripcion: pers.descripcion,
          planningId: pers.planningId,
          id: pers.id,
        });
      }
    }

    this.perspectivaObj = this.ordenarPerspe(this.perspectivaObj);
    this.perspectivaObj.forEach((per) => {
      this.Oobjetivos.push({ perspectivaaa: per, objetivosss: [] });
    });
  }


  private async obtDataIndicadoresMetas(): Promise<void> {
    try {
      const response = this.dataPlanificacion;
      if (response.id) {
        this.configurarFechasYFiltros(response);
        await this.obtenerAreas(response);
      }
      this.dataPerspectivas = await firstValueFrom(this.perspectivaService.getPerspectivas());
      this.perPers(this.dataPerspectivas);

      this.perspectivasIndMet = this.ordenamientoPer(this.perspectivasIndMet);
      this.objetivosIndMet = this.ordenamientoPer(this.objetivosIndMet);


      await this.obtenerUnidadesMedida();
      await this.procesarIndicadores();
      await this.obtDataProyectosEstrategicos();
    } catch (error) {
    }
  }

  /*   private async procesarPlanificacionesIndicadores(response: any[]): Promise<void> {
      for (const plan of response) {
        if (this.planeacionId === Number(plan.id)) {
          this.configurarFechasYFiltros(plan);
          await this.obtenerAreas(plan);
        }
      }
    } */

  private configurarFechasYFiltros(plan: any): void {
    // Usar moment para crear las fechas
    const fechaini = moment(plan.initial_date).toDate();
    const fechafin = moment(plan.end_date).toDate();

    this.configurarFiltrosDias(plan.business_days);
    this.configurarAniosDisponibles(fechaini, fechafin);

    this.minDate = fechaini;
    this.maxDate = fechafin;
  }

  private configurarFiltrosDias(businessDays: string): void {
    switch (businessDays) {
      case 'Lunes-Viernes':
        this.myFilter = (d: Date | null): boolean => {
          const day = moment(d || new Date()).day();
          return day !== 0 && day !== 6; // 0 = Domingo, 6 = Sábado
        };
        break;
      case 'Lunes-Sabado':
        this.myFilter = (d: Date | null): boolean => {
          const day = moment(d || new Date()).day();
          return day !== 0; // 0 = Domingo
        };
        break;
      case 'Lunes-Domingo':
        this.myFilter = (d: Date | null): boolean => true;
        break;
      default:
        this.myFilter = (d: Date | null): boolean => {
          const day = moment(d || new Date()).day();
          return day !== 0 && day !== 6;
        };
        break;
    }
  }

  private configurarAniosDisponibles(fechaini: Date, fechafin: Date): void {
    this.aniosDisponibles = [];
    const yearInicial = moment(fechaini).year();
    const yearFinal = moment(fechafin).year();

    for (let i = yearInicial; i <= yearFinal; i++) {
      this.aniosDisponibles.push({
        name: i.toString(),
        check: i === yearInicial,
      });
    }
  }

  private async obtenerAreas(plan: any): Promise<void> {
    try {
      const areasResponse = this.dataResponsables;
      this.areas = [];

      for (const responsable of areasResponse) {
        this.areas.push({
          id: responsable.id,
          nombre: responsable.cargo,
        });
      }

      this.areas = this.ordenamientoPer(this.areas);
    } catch (error) {
    }
  }

  private async obtenerUnidadesMedida(): Promise<void> {
    try {
      const unidadesResponse = await firstValueFrom(this.indicadoresService.getUnides());
      this.unidades_med = [];

      for (const uni of unidadesResponse) {
        this.unidades_med.push({
          nombre: uni.name,
          id: uni.id,
        });
      }
      this.unidades_med = this.ordenamientoPer(this.unidades_med);
    } catch (error) {
    }
  }

  private async procesarIndicadores(): Promise<void> {
    try {
      const objetivosIds = this.dataObjetivos.map(obj => obj.id);
      const indicadoresResponse = []
      for (let i = 0; i < objetivosIds.length; i += 10) {
        const batch = objetivosIds.slice(i, i + 10);
        const results = await Promise.all(
          batch.map(id => this.indicadoresService.getIndicadoresByObjetiveGQL(id))
        );
        indicadoresResponse.push(...results.flat());
      }
      this.dataIndicadores = indicadoresResponse;
      this.indPers(indicadoresResponse);
      this.indicadoresIndMet = this.ordenamientoPer(this.indicadoresIndMet);
      this.indicadoresIndMet = this.ordenamientoInd(this.indicadoresIndMet);
      this.metas = this.ordenamientoPer(this.metas);
    } catch (error) {
    }
  }

  private obtObjetivos(response) {
    for (const per of this.Oobjetivos) {
      per.objetivosss = [];
      for (const obj of response) {
        if (obj.perspective.id === per.perspectivaaa.id) {
          per.objetivosss.push({
            nombre: obj.name,
            descripcion: obj.description,
            ponderacion: obj.weighing,
            perspectiveId: obj.perspectiveId,
            responsableId: obj.responsibles,
            id: obj.id,
          });
          this.objetivos.push({
            nombre: obj.name,
            descripcion: obj.description,
            ponderacion: obj.weighing,
            perspectiveId: obj.perspectiveId,
            responsableId: obj.responsibles,
            id: obj.id,
          });
          per.objetivosss = this.ordenarPerspe(per.objetivosss);
        }
      }
    }
    this.objetivos = this.ordenarPerspe(this.objetivos);
  }

  public perPers(array: any) {
    var aux = [],
      aux2 = [];
    for (const per of array) {
      if (Number(per.planningId) === Number(this.planeacionId)) {
        aux.push({
          nombre: per.name,
          descripcion: per.descripcion,
          planningId: per.planningId,
          id: per.id,
          check: true,
        });
        for (const obj of per.objectives) {
          aux2.push({
            nombre: obj.name,
            descripcion: obj.description,
            ponderacion: obj.weighing,
            perspectiveId: per.id,
            id: obj.id,
          });
        }
      }
    }
    this.perspectivasIndMet = [];
    this.objetivosIndMet = [];
    this.perspectivasIndMet = aux;
    this.objetivosIndMet = aux2;
  }

  public indPers(array: any) {
    var aux = [],
      aux2 = [];
    for (const ind of array) {
      for (const obj of this.objetivosIndMet) {
        if (obj.id === ind.objective.id) {
          aux.push({
            id: ind.id,
            nombre: ind.name,
            objetivo: obj.nombre,
            descripcion: ind.description,
            calculo: ind.calculation,
            ponderacion: ind.weighing,
            objetiveId: ind.objective.id,
            linea_base: ind.baseline,
            fecha_inicio: moment(ind.initial_date).toDate(),
            fecha_fin: moment(ind.end_date).toDate(),
            periodicidad: ind.periodicity,
            meta_global: ind.globalGoal,
            measureId: ind.measure.id,
            areaId: ind.area.id,
            tendencia: ind.tendency,
            parametro: ind.param_type,
            adadicionales: this.ordenamientoAdi(ind.additions),
          });
          for (const met of ind.goals) {
            const date = this.obtFech(met.period);
            aux2.push({
              id: met.id,
              nombre: date,
              descripcion: met.value,
              indicatorId: ind.id,
            });
          }
        }
      }
    }
    this.indicadoresIndMet = [];
    this.metas = [];

    this.indicadoresIndMet = aux;
    this.metas = aux2;
  }

  private async obtDataProyectosEstrategicos(): Promise<void> {

    try {
      const response = this.dataPlanificacion;
      if (response.id) {
        this.configurarFechasProyectos(response);
        await this.obtenerResponsablesProyectos(response);
      }

      const perspectivasResponse = this.dataPerspectivas;
      this.perPersPE(perspectivasResponse);
      this.perspectivasPE = this.ordenamientoPer(this.perspectivasPE);
      this.objetivosPE = this.ordenamientoPer(this.objetivosPE);

      await this.procesarProyectosYActividades();
      await this.procesarEstrategias();
    } catch (error) {
    }
  }

    private async procesarPlanificacionesProyectos(response: any[]): Promise<void> {
      for (const plan of response) {
        if (this.planeacionId === Number(plan.id)) {
          this.configurarFechasProyectos(plan);
          await this.obtenerResponsablesProyectos(plan);
        }
      }
    }

  private configurarFechasProyectos(plan: any): void {
    const fechaini = moment(plan.initial_date).toDate();
    const fechafin = moment(plan.end_date).toDate();

    this.configurarFiltrosDiasProyectos(plan.business_days);
    this.configurarAniosDisponiblesProyectos(fechaini, fechafin);

    this.minDatePE = fechaini;
    this.maxDatePE = fechafin;
  }

  private configurarFiltrosDiasProyectos(businessDays: string): void {
    // Similar a configurarFiltrosDias pero para proyectos estratégicos
    this.configurarFiltrosDias(businessDays);
  }

  private configurarAniosDisponiblesProyectos(fechaini: Date, fechafin: Date): void {
    this.aniosDisponiblesPE = [];
    const yearInicial = moment(fechaini).year();
    const yearFinal = moment(fechafin).year();

    for (let i = yearInicial; i <= yearFinal; i++) {
      this.aniosDisponiblesPE.push({
        name: i.toString(),
        check: i === yearInicial,
      });
    }
  }

  private async obtenerResponsablesProyectos(plan: any): Promise<void> {
    try {
      const responsableResponse = this.dataResponsables
      this.responsablesPE = [];
      this.responsablesAct = [];

      for (const are of responsableResponse) {
        for (const res of are.responsibles) {
          const responsable = {
            nombre: res.position,
            apellido_materno: '',
            apellido_paterno: '',
            id: res.id,
            check: true,
          };
          this.responsablesPE.push(responsable);
          this.responsablesAct.push({ ...responsable });
        }
      }

      this.responsablesPE = this.ordenamientoPer(this.responsablesPE);
      this.responsablesAct = this.ordenamientoPer(this.responsablesAct);
    } catch (error) {
    }
  }


  private async procesarProyectosYActividades(): Promise<void> {
    try {
      let proyects = [];
      proyects = proyects.concat(
        this.dataObjetivos.flatMap(objetivo => objetivo.projects.map(p => p.id))
      );
      proyects = [...new Set(proyects)];
      const proyectosResponse = [];
      for (let i = 0; i < proyects.length; i += 10) {
        const batch = proyects.slice(i, i + 10);
        const results = await this.proyectosService.getProyectsGQL(batch);
        proyectosResponse.push(...results);
      }
      this.perProyec(proyectosResponse);
      this.proyectos = this.ordenamientoPer(this.proyectos);
      this.dataActivities = this.proyectos.flatMap(proyecto => proyecto.activities);

      this.perActiv(this.dataActivities);
      this.actividades = this.ordenamientoPer(this.actividades);
      this.obtfechasProy();
    } catch (error) {
    }
  }

  private async procesarEstrategias(): Promise<void> {
    try {
      let estrategias = [];
      estrategias = estrategias.concat(
        this.dataObjetivos.flatMap(objetivo => objetivo.strategies.map(s => s.id))
      );
      estrategias = [...new Set(estrategias)];
      const estrategiasResponse = await this.estrategiaService.getStrategyGQL(estrategias); 
      this.estrategias = [];

      for (const est of estrategiasResponse) {
        for (const obj of this.objetivosPE) {
          if (est.objectives.length !== 0 && obj.id === est.objectives[0].id) {
            this.estrategias.push({
              name: est.name,
              description: est.description,
              objetiveId: est.objectives,
              id: est.id,
            });
          }
        }
      }
      this.estrategias = this.ordenamientoPer(this.estrategias);
      this.dataEstrategias = this.estrategias;
    } catch (error) {
    }
  }


  public perPersPE(array: any) {
    var aux = [],
      aux2 = [];
    for (const per of array) {
      if (Number(per.planning.id) === Number(this.planeacionId)) {
        aux.push({
          nombre: per.name,
          descripcion: per.descripcion,
          planningId: per.planning.id,
          id: per.id,
          check: true,
          objetive: per.objectives,
        });
        for (const obj of per.objectives) {
          aux2.push({
            nombre: obj.name,
            descripcion: obj.description,
            ponderacion: obj.weighing,
            perspectiveId: per.id,
            id: obj.id,
            objetive: { ...obj },
          });
        }
      }
    }
    this.perspectivasPE = [];
    this.objetivosPE = [];
    this.perspectivasPE = aux;
    this.objetivosPE = aux2;
  }

  public perProyec(array: any) {
    var aux = [];
    for (const pro of array) {
      for (const ob of this.objetivosPE) {
        if (pro.objectives.length !== 0 && pro.objectives[0].id === ob.id) {
          var objectiveid = [];
          for (const objid of pro.objectives) {
            objectiveid.push(objid.id);
          }
          var estrategiaId: any = [];
          for (const estId of pro.strategies) {
            estrategiaId.push(estId.id);
          }
          const activitiesConProyecto = (pro.activities || []).map(act => ({
            ...act,
            projectId: pro.id
          }));
          aux.push({
            nombre: pro.name,
            ponderacion: pro.projectWeighing,
            objetiveId: ob,
            programasId: estrategiaId,
            responsableId: pro.responsible,
            id: pro.id,
            descripcion: pro.description,
            activities: activitiesConProyecto,
          });
          break;
        }
      }
    }
    this.proyectos = [];
    this.proyectos = aux;
    this.obtfechasProy();
  }

  public perActiv(array: any) {
    var aux = [];
    for (const act of array) {
      for (const pro of this.proyectos) {
        if (pro.id === act.projectId) {
          aux.push({
            nombre: act.name,
            fecha_inicio: moment(act.initial_date).toDate(),
            fecha_fin: moment(act.end_date).toDate(),
            projectId: act.projectId,
            responsableId: act.responsible.id,
            id: act.id,
            adicionales: this.ordenamientoAdi(act.additions),
          });
        }
      }
    }
    this.actividades = [];
    this.actividades = aux;
    this.obtfechasProy();
  }

  //FECHAS
  public obtFecha(fecha: any): string {
    if (!fecha) return '';

    if (fecha instanceof Date || typeof fecha === 'string') {
      return moment(fecha).format('DD-MM-YYYY');
    }

    return '';
  }

  private obtFech(isodate: any) {
    if (!isodate) return new Date();

    // Usar moment para parsear la fecha ISO
    return moment(isodate).toDate();
  }

  public obtfechasProy() {
    for (const pro of this.proyectos) {
      pro.fecha_fin = undefined;
      pro.fecha_ini = undefined;
      for (const act of this.actividades) {
        if (pro.id === act.projectId) {
          if (pro.fecha_ini === undefined) {
            pro.fecha_ini = act.fecha_inicio;
          } else {
            if (pro.fecha_ini > act.fecha_inicio) {
              pro.fecha_ini = act.fecha_inicio;
            }
          }
          if (pro.fecha_fin === undefined) {
            pro.fecha_fin = act.fecha_fin;
          } else {
            if (pro.fecha_fin < act.fecha_fin) {
              pro.fecha_fin = act.fecha_fin;
            }
          }
        }
      }
    }
  }

  //METODOS DE ORDENAMIENTO
  private ordenamientoPer(array: any) {
    array.sort(function (a: any, b: any) {
      if (Number(a.id) > Number(b.id)) {
        return 1;
      }
      if (Number(a.id) < Number(b.id)) {
        return -1;
      }
      return 0;
    });
    return array;
  }

  private ordenarConceptos(array: any) {
    array.sort(function (a: any, b: any) {
      if (Number(a.id) > Number(b.id)) {
        return 1;
      }
      if (Number(a.id) < Number(b.id)) {
        return -1;
      }
      return 0;
    });
    return array;
  }

  private ordenarPerspe(array: any) {
    array.sort(function (a: any, b: any) {
      if (Number(a.id) > Number(b.id)) {
        return 1;
      }
      if (Number(a.id) < Number(b.id)) {
        return -1;
      }
      return 0;
    });
    return array;
  }

  private ordenamientoInd(array: any) {
    array.sort(function (a: any, b: any) {
      if (Number(a.objetiveId) > Number(b.objetiveId)) {
        return 1;
      }
      if (Number(a.objetiveId) < Number(b.objetiveId)) {
        return -1;
      }
      return 0;
    });
    return array;
  }

  private ordenamientoAdi(array: any) {
    array.sort(function (a: any, b: any) {
      if (a.name > b.name) {
        return 1;
      }
      if (a.name < b.name) {
        return -1;
      }
      return 0;
    });
    return array;
  }


  private getFloaV1(res) {
    for (const per of this.diccionarioFLOA1) {
      per.elementooo = [];
      for (const pers of per.perspectivaaa) {
        for (const matrizf of res) {
          if (matrizf.perspectiveId === pers.id && !matrizf.name.includes('&&')) {
            if (matrizf.type === per.internosss.type) {
              per.elementooo.push({
                id: matrizf.id,
                tipo: matrizf.type,
                nombre: matrizf.name,
                perspectiveId: matrizf.perspectiveId,
              });
              per.elementooo = this.ordenarPerspe(per.elementooo);
            }
          }
        }
      }
    }
    for (const per of this.diccionarioFLOA2) {
      per.elementooo = [];
      for (const pers of per.perspectivaaa) {
        for (const matrizf of res) {
          if (matrizf.perspectiveId === pers.id && !matrizf.name.includes('&&')) {
            if (matrizf.type === per.externosss.type) {
              per.elementooo.push({
                id: matrizf.id,
                tipo: matrizf.type,
                nombre: matrizf.name,
                perspectiveId: matrizf.perspectiveId,
              });
              per.elementooo = this.ordenarPerspe(per.elementooo);
            }
          }
        }
      }
    }
  }
  private getFloaV2(res) {
    this.elemento = [];
    for (const mat of res) {
      const ex = this.perspectiva.filter(per => Number(per.id) === Number(mat.perspective.id));
      if (ex.length !== 0 && mat.name.includes('&&')) {
        this.elemento.push(mat);
      }
    }
    this.elemento = this.ordenarPerspe(this.elemento);

    for (const dicc of this.diccionarioFLOA1V2) {
      const elements = this.elemento.filter(mat => mat.type === dicc['internosss'].type);
      dicc.elementooo = [];
      if (elements.length !== 0) {
        for (const elem of elements) {
          dicc.elementooo.push({
            id: elem.id,
            tipo: elem.type,
            nombre: elem.name.split('&&')[0],
            perspectiveId: elem.perspectiveId,
            pestel: ''
          });
          dicc.elementooo = this.ordenarPerspe(dicc.elementooo);
        }
      }
    }

    for (const dicc of this.diccionarioFLOA2V2) {
      const elements = this.elemento.filter(mat => mat.type === dicc['externosss'].type);
      dicc.elementooo = [];
      if (elements.length !== 0) {
        for (const elem of elements) {
          dicc.elementooo.push({
            id: elem.id,
            tipo: elem.type,
            nombre: elem.name.split('&&')[0],
            perspectiveId: elem.perspectiveId,
            pestel: elem.name.split('&&')[1],
          });
          dicc.elementooo = this.ordenarPerspe(dicc.elementooo);
        }
      }
    }
  }

  public async guardarIntroPlanificacion(): Promise<void> {
    try {
      const elemento = document.getElementById('txt_introduccion') as HTMLInputElement;
      const introduccionValue = elemento?.value || '';

      const response = await firstValueFrom(
        this.altaplanificacionesService.patchReportIntro(
          this.planeacionId.toString(),
          introduccionValue
        )
      );

      if (response) {
        messages.succesMessageGraph(this.translateService.instant('gestion.reportes.planEs.introduccionGuardadaExitosamente'));
      }
    } catch (error) {
      messages.errorMessageGraph(this.translateService.instant('gestion.reportes.planEs.errorAlGuardarIntroduccion'));
    }
  }

  async generarReporte() {
    Swal.fire({
      title: this.translateService.instant('gestion.reportes.planEs.generandoReporte'),
      html: this.translateService.instant('gestion.reportes.planEs.porFavorEspere'),
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading(undefined);
      },
    });

    await this.DescargarPDF();
    if (this.reporteGeneradoExitosamente) {
      Swal.close();
      Swal.fire({
        title: this.translateService.instant('gestion.reportes.planEs.reporteDescargadoExitosamente'),
        text: this.translateService.instant('gestion.reportes.planEs.puedeEncontrarArchivo'),
        timer: 15000,
      });
    }
  }


  iconoPerspectivas(pos, per) {
    if (per.nombre.includes('Financiera')) {
      return 'assets/img/reportes/perspectivas/0.png';
    } else if (per.nombre.includes('Tecnología') || per.nombre.includes('Innovación') || per.nombre.includes('Gestión')) {
      return 'assets/img/reportes/perspectivas/2.png';
    } else if (per.nombre.includes('Crecimiento') || per.nombre.includes('Aprendizaje')) {
      return 'assets/img/reportes/perspectivas/3.png';
    } else if (per.nombre.includes('Gobernabilidad') || per.nombre.includes('Social')) {
      return 'assets/img/reportes/perspectivas/4.png';
    } else if (per.nombre.includes('Responsabilidad')) {
      return 'assets/img/reportes/perspectivas/5.png';
    } else if (per.nombre.includes('Cliente') || per.nombre.includes('Mercado') || per.nombre.includes('Socio') || per.nombre.includes('Asociados')) {
      return 'assets/img/reportes/perspectivas/6.png';
    } else if (per.nombre.includes('Educación')) {
      return 'assets/img/reportes/perspectivas/7.png';
    } else if (per.nombre.includes('Procesos') || per.nombre.includes('Internos')) {
      return 'assets/img/reportes/perspectivas/8.png';
    } else if (per.nombre.includes('Comunidades')) {
      return 'assets/img/reportes/perspectivas/9.png';
    } else {
      return 'assets/img/reportes/perspectivas/4.png'
    }
  }

  async obtenerLogo(): Promise<void> {
    try {
      const response = await firstValueFrom(
        this.reportesService.getLogo(this.companyId)
      );

      for (const doc of response) {
        const name = ('' + doc['filename']).split('.');
        const nomsep = name[0].split('_');

        for (const nam of nomsep) {
          if (nam.toLocaleLowerCase() === 'logo') {
            try {
              const archivoResponse = await firstValueFrom(
                this.reportesService.getArchivosA(doc._id)
              );

              const base = 'data:image/' + name[name.length - 1] + ';base64,' +
                btoa(new Uint8Array(archivoResponse).reduce((data, byte) =>
                  data + String.fromCharCode(byte), ''));

              this.imgLogo = base;

              // Si solo necesitas el primer logo encontrado, puedes hacer return aquí
              return;
            } catch (error) {
            }
            break;
          }
        }
      }
    } catch (error) {
    }
  }

  myFilter = (d: Date | null): boolean => {
    const day = moment(d || new Date()).day();
    return day !== 0 && day !== 6;
  };

  // Obtención de los codigos
  public obtCodigo(inter: any) {
    switch (inter.id) {
      case 1:
        return 'F';
      case 2:
        return 'D';
      case 3:
        return 'O';
      case 4:
        return 'A';
    }
    return 'no';
  }

  public mostrarPers(per: any, ind: any) {
    var anio: any,
      anioInd = ind.fecha_fin.getFullYear();
    for (const an of this.aniosDisponibles) {
      if (an.check) {
        anio = an.name;
        break;
      }
    }
    for (const obj of this.objetivosIndMet) {
      if (
        Number(obj.id) === Number(ind.objetiveId) &&
        Number(obj.perspectiveId) === Number(per) &&
        anio <= anioInd
      ) {
        return true;
      }
    }
    return false;
  }


  async getimgCmi() {
    await html2canvas(document.querySelector('#cmi_img'), {
      scale: 2.5,
      onclone: (doc) => {
        doc.getElementById('cmi_img_container').style.display = 'block';
      },
    }).then((canvas) => {
      this.imgCmi = canvas.toDataURL();
    });
  }

  async getFloa_img() {
    await html2canvas(document.querySelector('#floa_img'), {
      scale: 2.5,
      onclone: (doc) => {
        doc.getElementById('floa_img_cont').style.display = 'block';
      },
    }).then((canvas) => {
      this.imgFloa = canvas.toDataURL();
    });
  }

  private matrizFodaReporte() {
    let table1 = {
      widths: ['*', '*'],
      body: [
        [
          {
            text: ' \n',
            fontSize: 16,
            color: '#0455B2',
            fillColor: '#FFFFFF',
            alignment: 'left',
            border: [false, false, false, false],
          },
          {
            text: '',
            fillColor: '#FFFFFF',
            border: [false, false, false, false],
          },
        ],
        [
          {
            text: this.translateService.instant('gestion.reportes.planEs.elementosInternos') + '\n',
            fontSize: 16,
            color: '#0455B2',
            fillColor: '#FFFFFF',
            colSpan: 2,
            alignment: 'left',
            border: [false, false, false, false],
          },
          { text: '', fillColor: '#FFFFFF' },
        ],
      ],
    };

    let t1 = {
      table: {
        headerRows: 1,
        widths: [45, 190],
        body: [],
        layout: 'noBorders',
      },
      border: [false, false, true, false],
      fillColor: '#eeeeee',
      layout: {
        hLineColor: function (i) {
          return '#B6CDE0';
        },
        vLineColor: function (i, node) {
          return 'white';
        },
      },
    };
    let t2 = {
      table: {
        headerRows: 1,
        widths: [45, 190],
        body: [],
      },
      layout: {
        hLineColor: function (i) {
          return '#B6CDE0';
        },
        vLineColor: function (i, node) {
          return 'white';
        },
      },
      border: [false, false, false, false],
      fillColor: '#eeeeee',
    };
    let tab: any = [];
    tab.push([
      {
        text: this.diccionarioFLOA1[0].internosss.elemento,
        bold: true,
        style: 'tableHeader',
        colSpan: 2,
        alignment: 'left',
        border: [false, false, false, true],
        fontSize: 12,
        margin: [15, 5, 0, 5],
        fillColor: '#eeeeee',
        color: '#414042',
      },
      {
        text: '',
        style: 'tableHeader',
        border: [false, false, false, true],
      },
    ]);
    let i = 1;
    for (const ele of this.diccionarioFLOA1[0].elementooo) {
      tab.push([
        {
          text: this.obtCodigo(this.diccionarioFLOA1[0].internosss) + '-' + i,
          border: [false, false, false, false],
          margin: [15, 5, 0, 0],
          fontSize: 11,
          color: '#414042',
        },
        {
          text: ele.nombre,
          border: [false, false, false, false],
          fontSize: 11,
          color: '#414042',
          margin: [0, 5, 0, 0],
        },
      ]);
      i++;
    }
    let tab2: any = [];
    tab2.push([
      {
        text: this.diccionarioFLOA1[1].internosss.elemento,
        bold: true,
        style: 'tableHeader',
        colSpan: 2,
        alignment: 'left',
        border: [false, false, false, true],
        fontSize: 12,
        margin: [15, 5, 0, 5],
        fillColor: '#eeeeee',
        color: '#414042',
      },
      {
        text: '',
        style: 'tableHeader',
        border: [false, false, false, true],
      },
    ]);
    let j = 1;
    for (const ele of this.diccionarioFLOA1[1].elementooo) {
      tab2.push(
        [
          {
            text: this.obtCodigo(this.diccionarioFLOA1[1].internosss) + '-' + j,
            border: [false, false, false, false],
            margin: [15, 5, 0, 0],
            fontSize: 11,
            color: '#414042',
          },
          {
            text: ele.nombre,
            border: [false, false, false, false],
            fontSize: 11,
            color: '#414042',
            margin: [0, 5, 0, 0],
          },
        ]
      );
      j++;
    }
    t1.table.body = tab;
    t2.table.body = tab2;
    t1.table.body.push([
      { text: ' ', border: [false, false, false, false] },
      { text: '', border: [false, false, false, false] },
    ]);
    t1.table.body.push([
      { text: ' ', border: [false, false, false, false] },
      { text: '', border: [false, false, false, false] },
    ]);
    t2.table.body.push([
      { text: ' ', border: [false, false, false, false] },
      { text: '', border: [false, false, false, false] },
    ]);
    t2.table.body.push([
      { text: ' ', border: [false, false, false, false] },
      { text: '', border: [false, false, false, false] },
    ]);

    // @ts-ignore
    table1.body.push([t1, t2]);
    table1.body.push(
      [
        {
          text: ' \n',
          fontSize: 16,
          color: '#0455B2',
          fillColor: '#FFFFFF',
          alignment: 'left',
          border: [false, false, true, true],
        },
        {
          text: '',
          fillColor: '#FFFFFF',
          border: [false, false, false, true],
        },
      ],
      [
        {
          text: ' \n',
          fontSize: 16,
          color: '#0455B2',
          fillColor: '#FFFFFF',
          alignment: 'left',
          border: [false, false, true, false],
        },
        {
          text: '',
          fillColor: '#FFFFFF',
          border: [false, false, false, false],
        },
      ],
      [
        {
          text: this.translateService.instant('gestion.reportes.planEs.elementosExternos') + '\n',
          fontSize: 16,
          color: '#0455B2',
          fillColor: '#FFFFFF',
          alignment: 'left',
          border: [false, false, true, false],
        },
        {
          text: '',
          fillColor: '#FFFFFF',
          border: [false, false, false, false],
        },
      ]
    );

    let t3 = {
      table: {
        headerRows: 1,
        widths: [45, 190],
        body: [],
        layout: 'noBorders',
      },
      border: [false, false, true, false],
      fillColor: '#eeeeee',
      layout: {
        hLineColor: function (i) {
          return '#B6CDE0';
        },
        vLineColor: function (i, node) {
          return 'white';
        },
      },
    };
    let t4 = {
      table: {
        headerRows: 1,
        widths: [45, 190],
        body: [],
        layout: 'noBorders',
      },
      border: [false, false, false, false],
      fillColor: '#eeeeee',
      layout: {
        hLineColor: function (i) {
          return '#B6CDE0';
        },
        vLineColor: function (i, node) {
          return 'white';
        },
      },
    };

    let tab3: any = [];
    tab3.push([
      {
        text: this.diccionarioFLOA2[0].externosss.elemento,
        bold: true,
        style: 'tableHeader',
        colSpan: 2,
        alignment: 'left',
        border: [false, false, false, true],
        fontSize: 12,
        margin: [15, 5, 0, 5],
        fillColor: '#eeeeee',
        color: '#474648',
      },
      {
        text: '',
        style: 'tableHeader',
        border: [false, false, false, true],
      },
    ]);
    let k = 1;
    for (const ele of this.diccionarioFLOA2[0].elementooo) {
      tab3.push([
        {
          text: this.obtCodigo(this.diccionarioFLOA2[0].externosss) + '-' + k,
          border: [false, false, false, false],
          margin: [15, 5, 0, 0],
          fontSize: 11,
          color: '#474648',
        },
        {
          text: ele.nombre,
          border: [false, false, false, false],
          fontSize: 11,
          color: '#474648',
          margin: [0, 5, 0, 0],
        },
      ]);
      k++;
    }

    let tab4: any = [];
    tab4.push([
      {
        text: this.diccionarioFLOA2[1].externosss.elemento,
        bold: true,
        style: 'tableHeader',
        colSpan: 2,
        alignment: 'left',
        border: [false, false, false, true],
        fontSize: 12,
        margin: [15, 5, 0, 5],
        fillColor: '#eeeeee',
        color: '#474648',
      },
      {
        text: '',
        style: 'tableHeader',
        border: [false, false, false, true],
      },
    ]);
    let l = 1;
    for (const ele of this.diccionarioFLOA2[1].elementooo) {
      tab4.push([
        {
          text: this.obtCodigo(this.diccionarioFLOA2[1].externosss) + '-' + l,
          border: [false, false, false, false],
          margin: [15, 5, 0, 0],
          fontSize: 11,
          color: '#474648',
        },
        {
          text: ele.nombre,
          border: [false, false, false, false],
          fontSize: 11,
          color: '#474648',
          margin: [0, 5, 0, 0],
        },
      ]);
      l++;
    }
    t3.table.body = tab3;
    t4.table.body = tab4;
    t3.table.body.push([
      { text: ' ', border: [false, false, false, false] },
      { text: '', border: [false, false, false, false] },
    ]);
    t3.table.body.push([
      { text: ' ', border: [false, false, false, false] },
      { text: '', border: [false, false, false, false] },
    ]);
    t4.table.body.push([
      { text: ' ', border: [false, false, false, false] },
      { text: '', border: [false, false, false, false] },
    ]);
    t4.table.body.push([
      { text: ' ', border: [false, false, false, false] },
      { text: '', border: [false, false, false, false] },
    ]);

    // @ts-ignore
    table1.body.push([t3, t4]);
    return table1;
  }


  private matrizFodaReporteV2() {
    let t1 = {
      table: {
        headerRows: 1,
        widths: [45, 190],
        body: [],
        layout: 'noBorders',
      },
      border: [false, false, true, false],
      fillColor: '#eeeeee',
      layout: {
        hLineColor: function (i) {
          return '#B6CDE0';
        },
        vLineColor: function (i, node) {
          return 'white';
        },
      },
    };
    let t2 = {
      table: {
        headerRows: 1,
        widths: [45, 190],
        body: [],
      },
      layout: {
        hLineColor: function (i) {
          return '#B6CDE0';
        },
        vLineColor: function (i, node) {
          return 'white';
        },
      },
      border: [false, false, false, false],
      fillColor: '#eeeeee',
    };
    let tab: any = [];
    tab.push([
      {
        text: this.diccionarioFLOA1V2[0].internosss.elemento,
        bold: true,
        style: 'tableHeader',
        colSpan: 2,
        alignment: 'left',
        border: [false, false, false, true],
        fontSize: 12,
        margin: [15, 5, 0, 5],
        fillColor: '#eeeeee',
        color: '#414042',
      },
      {
        text: '',
        style: 'tableHeader',
        border: [false, false, false, true],
      },
    ]);
    let i = 1;
    for (const ele of this.diccionarioFLOA1V2[0].elementooo) {
      tab.push([
        {
          text: this.obtCodigo(this.diccionarioFLOA1V2[0].internosss) + '-' + i,
          border: [false, false, false, false],
          margin: [15, 5, 0, 0],
          fontSize: 11,
          color: '#414042',
        },
        {
          text: ele.nombre,
          border: [false, false, false, false],
          fontSize: 11,
          color: '#414042',
          margin: [0, 5, 0, 0],
        },
      ]);
      i++;
    }
    let tab2: any = [];
    tab2.push([
      {
        text: this.diccionarioFLOA1V2[1].internosss.elemento,
        bold: true,
        style: 'tableHeader',
        colSpan: 2,
        alignment: 'left',
        border: [false, false, false, true],
        fontSize: 12,
        margin: [15, 5, 0, 5],
        fillColor: '#eeeeee',
        color: '#414042',
      },
      {
        text: '',
        style: 'tableHeader',
        border: [false, false, false, true],
      },
    ]);
    let j = 1;
    for (const ele of this.diccionarioFLOA1V2[1].elementooo) {
      tab2.push(
        [
          {
            text: this.obtCodigo(this.diccionarioFLOA1V2[1].internosss) + '-' + j,
            border: [false, false, false, false],
            margin: [15, 5, 0, 0],
            fontSize: 11,
            color: '#414042',
          },
          {
            text: ele.nombre,
            border: [false, false, false, false],
            fontSize: 11,
            color: '#414042',
            margin: [0, 5, 0, 0],
          },
        ]
      );
      j++;
    }
    t1.table.body = tab;
    t2.table.body = tab2;
    t1.table.body.push([
      { text: ' ', border: [false, false, false, false] },
      { text: '', border: [false, false, false, false] },
    ]);
    t1.table.body.push([
      { text: ' ', border: [false, false, false, false] },
      { text: '', border: [false, false, false, false] },
    ]);
    t2.table.body.push([
      { text: ' ', border: [false, false, false, false] },
      { text: '', border: [false, false, false, false] },
    ]);
    t2.table.body.push([
      { text: ' ', border: [false, false, false, false] },
      { text: '', border: [false, false, false, false] },
    ]);

    let t3 = {
      table: {
        headerRows: 1,
        widths: [45, 190],
        body: [],
        layout: 'noBorders',
      },
      border: [false, false, true, false],
      fillColor: '#eeeeee',
      layout: {
        hLineColor: function (i) {
          return '#B6CDE0';
        },
        vLineColor: function (i, node) {
          return 'white';
        },
      },
    };
    let t4 = {
      table: {
        headerRows: 1,
        widths: [45, 190],
        body: [],
        layout: 'noBorders',
      },
      border: [false, false, false, false],
      fillColor: '#eeeeee',
      layout: {
        hLineColor: function (i) {
          return '#B6CDE0';
        },
        vLineColor: function (i, node) {
          return 'white';
        },
      },
    };

    let tab3: any = [];
    tab3.push([
      {
        text: this.diccionarioFLOA2V2[0].externosss.elemento,
        bold: true,
        style: 'tableHeader',
        colSpan: 2,
        alignment: 'left',
        border: [false, false, false, true],
        fontSize: 12,
        margin: [15, 5, 0, 5],
        fillColor: '#eeeeee',
        color: '#474648',
      },
      {
        text: '',
        style: 'tableHeader',
        border: [false, false, false, true],
      },
    ]);
    let k = 1;
    for (const ele of this.diccionarioFLOA2V2[0].elementooo) {
      tab3.push([
        {
          text: this.obtCodigo(this.diccionarioFLOA2V2[0].externosss) + '-' + k,
          border: [false, false, false, false],
          margin: [15, 5, 0, 0],
          fontSize: 11,
          color: '#474648',
        },
        {
          text: ele.nombre,
          border: [false, false, false, false],
          fontSize: 11,
          color: '#474648',
          margin: [0, 5, 0, 0],
        },
      ]);
      k++;
    }

    let tab4: any = [];
    tab4.push([
      {
        text: this.diccionarioFLOA2V2[1].externosss.elemento,
        bold: true,
        style: 'tableHeader',
        colSpan: 2,
        alignment: 'left',
        border: [false, false, false, true],
        fontSize: 12,
        margin: [15, 5, 0, 5],
        fillColor: '#eeeeee',
        color: '#474648',
      },
      {
        text: '',
        style: 'tableHeader',
        border: [false, false, false, true],
      },
    ]);
    let l = 1;
    for (const ele of this.diccionarioFLOA2V2[1].elementooo) {
      tab4.push([
        {
          text: this.obtCodigo(this.diccionarioFLOA2V2[1].externosss) + '-' + l,
          border: [false, false, false, false],
          margin: [15, 5, 0, 0],
          fontSize: 11,
          color: '#474648',
        },
        {
          text: ele.nombre,
          border: [false, false, false, false],
          fontSize: 11,
          color: '#474648',
          margin: [0, 5, 0, 0],
        },
      ]);
      l++;
    }
    t3.table.body = tab3;
    t4.table.body = tab4;
    t3.table.body.push([
      { text: ' ', border: [false, false, false, false] },
      { text: '', border: [false, false, false, false] },
    ]);
    t3.table.body.push([
      { text: ' ', border: [false, false, false, false] },
      { text: '', border: [false, false, false, false] },
    ]);
    t4.table.body.push([
      { text: ' ', border: [false, false, false, false] },
      { text: '', border: [false, false, false, false] },
    ]);
    t4.table.body.push([
      { text: ' ', border: [false, false, false, false] },
      { text: '', border: [false, false, false, false] },
    ]);

    let table1 = {
      widths: ['*', '*'],
      body: [
        [
          {
            text: ' \n',
            fontSize: 16,
            color: '#0455B2',
            fillColor: '#FFFFFF',
            alignment: 'left',
            border: [false, false, false, false],
          },
          {
            text: '',
            fillColor: '#FFFFFF',
            border: [false, false, false, false],
          },
        ],
        [
          {
            text: this.translateService.instant('gestion.reportes.planEs.elementosExternos') + '\n',
            fontSize: 16,
            color: '#0455B2',
            fillColor: '#FFFFFF',
            colSpan: 2,
            alignment: 'left',
            border: [false, false, false, false],
          },
          { text: '', fillColor: '#FFFFFF' },
        ],
      ],
    };
    // @ts-ignore
    table1.body.push([t3, t4]);
    table1.body.push(
      [
        {
          text: ' \n',
          fontSize: 16,
          color: '#0455B2',
          fillColor: '#FFFFFF',
          alignment: 'left',
          border: [false, false, true, true],
        },
        {
          text: '',
          fillColor: '#FFFFFF',
          border: [false, false, false, true],
        },
      ],
      [
        {
          text: ' \n',
          fontSize: 16,
          color: '#0455B2',
          fillColor: '#FFFFFF',
          alignment: 'left',
          border: [false, false, true, false],
        },
        {
          text: '',
          fillColor: '#FFFFFF',
          border: [false, false, false, false],
        },
      ],
      [
        {
          text: this.translateService.instant('gestion.reportes.planEs.elementosInternos') + '\n',
          fontSize: 16,
          color: '#0455B2',
          fillColor: '#FFFFFF',
          alignment: 'left',
          border: [false, false, true, false],
        },
        {
          text: '',
          fillColor: '#FFFFFF',
          border: [false, false, false, false],
        },
      ]
    );
    // @ts-ignore
    table1.body.push([t1, t2]);
    return table1 ;
  }

  private proyectosEstrategicosReporte() {
    let data = [];
    let objetivosSet = new Map<String, Object[]>();

    this.proyectos.sort(function (a: any, b: any) {
      if (a.fecha_ini !== undefined && b.fecha_ini !== undefined) {
        if (a.fecha_ini.getTime() > b.fecha_ini.getTime()) {
          return 1;
        }
        if (a.fecha_ini.getTime() < b.fecha_ini.getTime()) {
          return -1;
        }
      }
      return 0;
    });

    for (const p of this.proyectos) {
      if (objetivosSet.has(p.objetiveId.nombre)) {
        let content: any = objetivosSet.get(p.objetiveId.nombre);
        content = [
          ...content,
          [
            {
              ul: [
                {
                  text: p.nombre,
                  color: '#808080',
                  fontSize: 11,
                },
              ],
              markerColor: '#4E9AC7',
              border: [false, false, false, false],
            },
            {
              text: this.obtFecha(p.fecha_ini),
              color: '#808080',
              border: [false, false, false, false],
              fontSize: 11,
            },
            {
              text: this.obtFecha(p.fecha_fin),
              color: '#808080',
              border: [false, false, false, false],
              fontSize: 11,
            },
            {
              text: p.responsableId.position,
              color: '#808080',
              border: [false, false, false, false],
              fontSize: 11,
            },
          ],
        ];
        objetivosSet.delete(p.objetiveId.nombre);
        objetivosSet.set(p.objetiveId.nombre, content);
      } else {
        objetivosSet.set(p.objetiveId.nombre, [
          [
            {
              text: this.translateService.instant('gestion.reportes.planEs.proyecto'),
              color: '#808080',
              border: [false, false, false, true],
              fontSize: 11,
            },
            {
              text: this.translateService.instant('gestion.reportes.planEs.fechaInicio'),
              color: '#808080',
              border: [false, false, false, true],
              fontSize: 11,
            },
            {
              text: this.translateService.instant('gestion.reportes.planEs.fechaFin'),
              color: '#808080',
              border: [false, false, false, true],
              fontSize: 11,
            },
            {
              text: this.translateService.instant('gestion.reportes.planEs.lider'),
              color: '#808080',
              border: [false, false, false, true],
              fontSize: 11,
            },
          ],
          [
            {
              ul: [
                {
                  text: p.nombre,
                  color: '#808080',
                  fontSize: 11,
                },
              ],
              markerColor: '#4E9AC7',
              border: [false, false, false, false],
            },
            {
              text: this.obtFecha(p.fecha_ini),
              color: '#808080',
              border: [false, false, false, false],
              fontSize: 11,
            },
            {
              text: this.obtFecha(p.fecha_fin),
              color: '#808080',
              border: [false, false, false, false],
              fontSize: 11,
            },
            {
              text: p.responsableId.position,
              color: '#808080',
              border: [false, false, false, false],
              fontSize: 11,
            },
          ],
        ]);
      }
    }
    // headerRows
    let table = {
      widths: ['*', 90, 90, 220],
      body: [],
    };
    objetivosSet.forEach((v, k) => {
      table.body = [
        ...table.body,
        [
          { text: ' ', colSpan: 4, border: [false, false, false, false] },
          { text: '', border: [false, false, false, false] },
          { text: '', border: [false, false, false, false] },
          { text: '', border: [false, false, false, false] },
        ],
        [
          {
            text: k,
            colSpan: 4,
            fillColor: '#eeeeee',
            color: '#808080',
            bold: true,
            fontSize: 11,
          },
          { text: '' },
          { text: '' },
          { text: '' },
        ],
        ...v,
      ];
    });
    if (table.body.length === 0) {
      table.body = [
        [
          { text: ' ', colSpan: 4, border: [false, false, false, false] },
          { text: '', border: [false, false, false, false] },
          { text: '', border: [false, false, false, false] },
          { text: '', border: [false, false, false, false] },
        ],
      ];
    }
    return table;
  }

  public colorCMI(indice: any) {
    switch (indice) {
      case 0:
        return '#003772';
      case 1:
        return '#004A97';
      case 2:
        return '#1A65A7';
      case 3:
        return '#347FB7';
      case 4:
        return '#4E9AC7';
      case 5:
        return '#79B2D1';
      case 6:
        return '#97CCE3';
      case 7:
        return '#A9D5E8';
      case 8:
        return '#B8DCEC';
    }
    return null;
  }

  private obtenerCMI() {
    const border = [false, false, false, false];
    let table = {
      widths: ['auto', 40, 200],
      body: [],
    };

    let i = 0;
    for (const per of this.diccionarioPerspectivas) {
      table.body.push([
        {
          text: per.perspectiva.nombre,
          colSpan: 3,
          color: '#0B4E97',
          border,
          margin: i > 0 ? [0, 30, 0, 10] : [0, 0, 0, 10],
          fontSize: 14,
        },
        { text: '', border },
        { text: '', border },
      ]);
      borderColor: ['white', '#F5F5F5', 'white', '#F5F5F5'];
      for (let j = 0; j < per.objetivos.length; j += 2) {
        let table2 = {
          widths: [40, 150, 10, 40, 150],
          body: [],
        };
        if (per.objetivos[j + 1]) {
          table2.body.push([
            {
              text: '' + per.perspectiva.nombre[0] + (j + 1),
              fillColor: this.colorCMI(i),
              borderColor: ['#F5F5F5', '#F5F5F5', '#F5F5F5', '#F5F5F5'],
              color: 'white',
              fontSize: 20,
              bold: true,
              margin: [10, 0, 0, 0],
            },
            {
              text: per.objetivos[j].nombre,
              borderColor: ['#F5F5F5', '#F5F5F5', '#F5F5F5', '#F5F5F5'],
              color: '#808080',
              fontSize: 11,
            },
            { text: '', border },
            {
              text: '' + per.perspectiva.nombre[0] + (j + 2),
              fillColor: this.colorCMI(i),
              borderColor: ['#F5F5F5', '#F5F5F5', '#F5F5F5', '#F5F5F5'],
              border: [false, true, true, true],
              color: 'white',
              fontSize: 20,
              bold: true,
              margin: [10, 0, 0, 0],
            },
            {
              text: per.objetivos[j + 1].nombre,
              borderColor: ['#F5F5F5', '#F5F5F5', '#F5F5F5', '#F5F5F5'],
              color: '#808080',
              fontSize: 11,
            },
          ]);
          table2.body.push([
            { text: '', border, fontSize: 11 },
            { text: '', border },
            { text: '', border, fontSize: 11 },
            { text: '', border },
            { text: '', border },
          ]);
        } else {
          table2.body.push([
            {
              text: '' + per.perspectiva.nombre[0] + (j + 1),
              fillColor: this.colorCMI(i),
              borderColor: ['#F5F5F5', '#F5F5F5', '#F5F5F5', '#F5F5F5'],
              color: 'white',
              fontSize: 20,
              bold: true,
              margin: [10, 0, 0, 0],
            },
            {
              text: per.objetivos[j].nombre,
              borderColor: ['#F5F5F5', '#F5F5F5', '#F5F5F5', '#F5F5F5'],
              color: '#808080',
              fontSize: 11,
            },
            { text: '', border },
            { text: '', border },
            { text: '', border },
          ]);
          table2.body.push([
            { text: '', border, fontSize: 11 },
            { text: '', border },
            { text: '', border },
            { text: '', border },
            { text: '', border },
          ]);
        }
        table.body.push([
          { table: table2, colSpan: 3, layout: 'noborders' },
          { text: '', layout: 'noborders' },
          { text: '', layout: 'noborders' },
        ]);
      }
      i++;
    }
    return table;
  }

  private objetivosEstrategicosReporte() {
    let table = {
      widths: ['*'],
      body: [],
    };
    let body = [];
    let i = 0;
    for (const per of this.Oobjetivos) {
      const title = {
        text: per.perspectivaaa.nombre,
        border: [false, false, false, true],
        color: '#808080',
        bold: true,
        fontSize: 11,
      };
      if (i > 0) {
        // @ts-ignore
        title.margin = [0, 15, 0, 0];
      }
      let elem = {
        ul: [],
        border: [false, false, false, false],
        markerColor: '#4E9AC7',
      };
      for (const ele of per.objetivosss) {
        elem.ul.push({ text: ele.nombre, color: '#808080', fontSize: 11 });
      }
      i++;
      body.push([title]);
      body.push([elem]);
    }
    table.body = body;
    return table;
  }
  private indicadoresMetasReporte() {
    let content = [];
    let table = {
      widths: ['*', '*'],
      body: [
        [
          {
            text: this.translateService.instant('gestion.reportes.planEs.objetivo'),
            style: 'tableHeader',
            fillColor: '#eeeeee',
            color: '#808080',
            bold: true,
            fontSize: 11,
          },
          {
            text: this.translateService.instant('gestion.reportes.planEs.indicador'),
            style: 'tableHeader',
            fillColor: '#eeeeee',
            color: '#808080',
            bold: true,
            fontSize: 11,
          },
        ],
      ],
    };
    let body = [];
    let perspectvas = [];
    for (let per of this.perspectivasIndMet) {
      let objetivos = new Map<String, Object[]>();
      let cols = [];
      let objetivo = null;
      let i = 0;
      for (let ele of this.indicadoresIndMet) {
        if (this.mostrarPers(per.id, ele)) {
          if (objetivos.has(ele.objetivo)) {
            let v: any = objetivos.get(ele.objetivo);
            v[0].ul = [
              ...v[0].ul,
              { text: (this.verCodigo ? this.translateService.instant('gestion.reportes.planEs.codigoPipe') : '') + '' + ele.nombre, color: '#808080', fontSize: 11 },
            ];
            objetivos.delete(ele.objetivo);
            objetivos.set(ele.objetivo, v);
          } else {
            objetivos.set(ele.objetivo, [
              {
                ul: [{ text: (this.verCodigo ? this.translateService.instant('gestion.reportes.planEs.codigoPipe') : '') + '' + ele.nombre, color: '#808080', fontSize: 11 }],
                markerColor: '#4E9AC7',
              },
            ]);
          }
        }
      }
      perspectvas.push([per.nombre, objetivos]);
    }
    let i = 0;
    for (const per of perspectvas) {
      let table = {
        widths: ['*', '*'],
        body: [
          [
            {
              text: this.translateService.instant('gestion.reportes.planEs.objetivo'),
              style: 'tableHeader',
              fillColor: '#eeeeee',
              color: '#808080',
              bold: true,
              fontSize: 11,
            },
            {
              text: this.translateService.instant('gestion.reportes.planEs.indicador'),
              style: 'tableHeader',
              fillColor: '#eeeeee',
              color: '#808080',
              bold: true,
              fontSize: 11,
            },
          ],
        ],
      };
      const t = {
        text: per[0],
        margin: [45, 15, 0, 0],
        bold: true,
        color: '#808080',
      };
      let keys = (per[1] as Map<String, String[]>).keys();
      for (const k of keys) {
        let o = {
          text: k,
          color: '#808080',
          fontSize: 11,
        };
        //  @ts-ignore
        table.body.push([[o], (per[1] as Map<String, String[]>).get(k)]);
      }
      if (i === 2) {
        content.push({ text: '', pageBreak: 'after' });
        content.push({
          text: this.translateService.instant('gestion.reportes.planEs.indicadoresClaveDesempeno'),
          style: 'header',
          fontSize: 24,
          color: '#0455B2',
          margin: [15, 0, 0, 0],
          alignment: 'left',
          bold: true,
        });
        content.push({
          text: this.translateService.instant('gestion.reportes.planEs.indicadoresMetasPerspectiva'),
          style: 'header',
          fontSize: 20,
          color: '#ACBD3D',
          margin: [15, 0, 0, 0],
          alignment: 'left',
        });

        content.push({
          text: [
            {
              text: this.translateService.instant('gestion.reportes.planEs.perspectivas') + '\n',
              fontSize: 16,
              color: '#0455B2',
              fillColor: '#FFFFFF',
              colSpan: 2,
              alignment: 'left',
              border: [false, false, false, false],
            },
          ],
          margin: [45, 15, 0, 0],
        });
      }
      content.push(t);
      content.push({
        table: table,
        layout: {
          hLineColor: function (i) {
            return '#E0E0E0';
          },
          vLineColor: function (i, node) {
            return 'white';
          },
        },
        margin: [45, 5, 0, 0],
      });
      i++;
    }
    return content;
  }

  private obtenerNombresPerspectivas() {
    let str = '';
    for (const per of this.perspectivas) {
      if (str === '') {
        str = per.nombre;
      } else {
        str += ', ' + per.nombre;
      }
    }

    return str.replace(/,(?=[^,]+$)/, ' y');
  }

  private filosofiaCorporativa() {
    let resp: any = [];
    for (const c of this.concepto) {
      resp.push(
        {
          text: `${c.name}\n`,
          style: 'header',
          fontSize: 16,
          color: '#0455B2',
          margin: [45, 15, 0, 0],
        },
        {
          text: `\n\n${c.description}\n\n\n\n`,
          alignment: 'justify',
          color: '#808080',
          fontSize: 11,
          margin: [45, 0, 0, 0],
        }
      );
    }
    return resp;
  }

  public async DescargarPDF() {
    try {
      this.reporteGeneradoExitosamente = false;
      this.isDownloadingPdf = true;

      const elemento = document.getElementById('txt_introduccion') as HTMLInputElement;
      const introduccion = elemento?.value || '';

      let cmi;
      if (this.imprimirCmi) {
        cmi = this.obtenerCMI();
      }
      if (this.imprimirMetodologia) {
        await this.getimgCmi();
      }
      let tableFoda;
      await this.getFloa_img();
      if (this.imprimirFoda && this.verFodaV1) {
        tableFoda = this.matrizFodaReporte();
      }
      let tableFodaV2;
      if (this.imprimirFodaV2 && this.verFodaV2) {
        tableFodaV2 = this.matrizFodaReporteV2();
      }
      let tableObjEst;
      if (this.imprimirObjetivos) {
        tableObjEst = this.objetivosEstrategicosReporte();
      }

      let tableIndMetas;
      if (this.imprimirIndicadores) {
        tableIndMetas = this.indicadoresMetasReporte();
      }
      let tableProyectosEstrategicos;
      if (this.imprimirPlanOperativo) {
        tableProyectosEstrategicos = this.proyectosEstrategicosReporte();
      }

      const logo = obtenerLogo.obtLogo(this.nombreInstitucion.acronimo);

      const fechaPiePag = moment().format('DD/MM/YY');
      const horaPiePag = moment().format('HH:mm:ss');
      const currentUser = this.dataService.user;

      const docDefinition = {
        images: {
          logoAleema: ConstantesImagenes.fondoblanco,
        },
        footer: function (currentPage, pageCount) {
          if (currentPage == 1) {
            return null;
          }
          if (currentPage === pageCount) {
            return {
              columns: [
                {
                  image: 'logoAleema',
                  width: 70,
                },

                {
                  text: `${currentUser}  |  ${fechaPiePag}  |  ${horaPiePag}`,
                  alignment: 'center',
                  width: '*',
                  color: '#808080',
                  fontSize: 10,
                },

                {
                  text: (currentPage - 1).toString(),
                  // alignment: 'right',
                  color: '#808080',
                  fontSize: 10,
                  width: 'auto',
                },
              ],
              margin: [25, -1, 30, 0],
            };
          } else {
            return {
              text:
              {
                text: (currentPage - 1).toString(),
                alignment: 'right',
                color: '#808080',
                fontSize: 10,
                width: 'auto',
              }, margin: [10, -1, 30, 0],

            }
          }
        },
        content: [
          this.imgLogo !== '' ? {
            image: this.imgLogo,
            width: 220,
            margin: [0, 0, 10, 0],
            absolutePosition: { y: 60 },
            alignment: 'right',
          } : { text: '' },
          {
            text: this.translateService.instant('gestion.reportes.planEs.informePlan'),
            style: 'header',
            bold: true,
            fontSize: 30,
            color: '#0455B2',
            // absolutePosition: { x: 90, y: 290 },
            margin: [60, 250, 0, 0],
          },
          {
            text: this.translateService.instant('gestion.reportes.planEs.estrategico'),
            style: 'header',
            bold: true,
            fontSize: 30,
            color: '#0455B2',
            margin: [60, 5, 0, 0],

            // absolutePosition: { x: 90, y: 330 },
          },
          {
            text: this.nombreInstitucion.nombre,
            style: 'header',
            bold: true,
            fontSize: 24,
            color: '#90BC40',
            margin: [60, 45, 0, 0],
            // absolutePosition: { x: 90, y: 400 },
          },
          {
            text: `${this.aniosDisponiblesPE[0].name} - ${this.aniosDisponiblesPE[this.aniosDisponiblesPE.length - 1].name
              }`,
            style: 'header',
            bold: true,
            fontSize: 20,
            color: '#0455B2',
            margin: [60, 45, 0, 0],
          },

          this.imprimirIntro
            ? [
              { text: '', pageBreak: 'after' },

              {
                text: this.translateService.instant('gestion.reportes.planEs.planEstrategico') + ' ' + `${this.aniosDisponiblesPE[0].name
                  } - ${this.aniosDisponiblesPE[this.aniosDisponiblesPE.length - 1]
                    .name
                  }`,
                style: 'header',
                fontSize: 24,
                color: '#0455B2',
                absolutePosition: { x: 50, y: 40 },
                bold: true,
              },
              {
                text: this.translateService.instant('gestion.reportes.planEs.introduccionMinuscula'),
                style: 'header',
                fontSize: 18,
                color: '#ACBD3D',
                absolutePosition: { x: 60, y: 70 },
              },
              {
                alignment: 'justify',
                text: introduccion,
                style: 'header',
                fontSize: 11,
                color: '#808080',
                absolutePosition: { x: 90, y: 130 },
                margin: [0, 18],
              },
            ]
            : null,

          this.imprimirMetodologia
            ? [
              { text: '', pageBreak: 'after' },
              {
                text: this.translateService.instant('gestion.reportes.planEs.metodologiaTrabajo'),
                style: 'header',
                fontSize: 24,
                color: '#0455B2',
                margin: [15, 0, 0, 0],
                bold: true,

                // absolutePosition: { x: 50, y: 40 },
              },
              {
                text: this.translateService.instant('gestion.reportes.planEs.cuadroMandoIntegral'),
                style: 'header',
                fontSize: 18,
                color: '#ACBD3D',
                margin: [25, 0, 0, 0],
              },
              {
                alignment: 'justify',
                text: [
                  {
                    text: this.translateService.instant('gestion.reportes.planEs.procesoMetodologico') + '\n\n',
                  },
                  {
                    text: this.translateService.instant('gestion.reportes.planEs.objetivoFundamental') + '\n\n',
                  },
                  {
                    text: this.translateService.instant('gestion.reportes.planEs.modeloApoyo') + ' ' + `${this.obtenerNombresPerspectivas().toLocaleLowerCase()}` + this.translateService.instant('gestion.reportes.planEs.permitenAlinear'),
                  },
                ],
                style: 'header',
                fontSize: 11,
                color: '#808080',
                margin: [45, 15, 0, 0],
              },
              {
                image: this.imgCmi,
                width: 400,
                alignment: 'center',
                margin: [45, 15, 0, 0],
              },
              {
                alignment: 'justify',
                text: this.translateService.instant('gestion.reportes.planEs.esquemaMetodologico'),
                style: 'header',
                fontSize: 11,
                color: '#808080',
                margin: [45, 15, 0, 0],
              },
              { text: '', pageBreak: 'after' },

              {
                text: this.translateService.instant('gestion.reportes.planEs.metodologiaTrabajo'),
                style: 'header',
                fontSize: 24,
                color: '#0455B2',
                margin: [15, 0, 0, 0],
                bold: true,
              },
              {
                text: this.translateService.instant('gestion.reportes.planEs.fasesPlaneacion'),
                style: 'header',
                fontSize: 18,
                color: '#ACBD3D',
                margin: [25, 0, 0, 0],
              },
              {
                text: [
                  { text: this.translateService.instant('gestion.reportes.planEs.faseDiagnostica'), bold: true },
                  this.translateService.instant('gestion.reportes.planEs.textoFaseDiagnostica'),
                  '\n\n',
                  { text: this.translateService.instant('gestion.reportes.planEs.faseEstrategica'), bold: true },
                  this.translateService.instant('gestion.reportes.planEs.textoFaseEstrategica'),
                  '\n\n',
                  this.translateService.instant('gestion.reportes.planEs.textoAlineamiento'),
                  '\n\n',
                  { text: this.translateService.instant('gestion.reportes.planEs.faseOperativaTitulo'), bold: true },
                  ' ',
                  this.translateService.instant('gestion.reportes.planEs.faseOperativaTexto'),
                  '\n\n',
                  { text: this.translateService.instant('gestion.reportes.planEs.faseSistematizacionTitulo'), bold: true },
                  this.translateService.instant('gestion.reportes.planEs.faseSistematizacionTexto'),
                  '\n\n',
                  { text: this.translateService.instant('gestion.reportes.planEs.faseSeguimientoTitulo'), bold: true },
                  this.translateService.instant('gestion.reportes.planEs.faseSeguimientoTexto'),
                ],
                color: '#808080',
                fontSize: 11,
                // absolutePosition: {x: 90, y: 120},
                alignment: 'justify',
                margin: [45, 15, 0, 0],
              },
            ]
            : null,

          this.imprimirFilosofia
            ? [
              { text: '', pageBreak: 'after' },
              {
                text: this.translateService.instant('gestion.reportes.planEs.filosofiaCorporativa'),
                style: 'header',
                fontSize: 24,
                color: '#0455B2',
                // absolutePosition: { x: 50, y: 40 },
                margin: [15, 0, 0, 0],
                bold: true,
              },
              {
                text: this.translateService.instant('gestion.reportes.planEs.misionVision'),
                style: 'header',
                fontSize: 18,
                color: '#ACBD3D',
                margin: [25, 0, 0, 0],
              },

              {
                text: [
                  {
                    text: this.translateService.instant('gestion.reportes.planEs.textoFilosofia'),
                  },
                ],
                color: '#808080',
                fontSize: 11,
                // absolutePosition: {x: 90, y: 120},
                alignment: 'justify',
                margin: [45, 15, 0, 0],
              },
              //TODO
              ...this.filosofiaCorporativa(),
            ]
            : null,

          this.imprimirFoda
            ? [
              { text: '', pageBreak: 'after' },
              {
                text: this.translateService.instant('gestion.reportes.planEs.matrizFodaTitulo'),
                style: 'header',
                fontSize: 24,
                color: '#0455B2',
                // absolutePosition: { x: 50, y: 40 },/
                margin: [15, 0, 0, 0],
                alignment: 'left',
                bold: true,
              },
              {
                text: this.translateService.instant('gestion.reportes.planEs.analisisEstrategico'),
                style: 'header',
                fontSize: 18,
                color: '#ACBD3D',
                margin: [25, 0, 0, 0],
              },
              {
                text: [
                  this.translateService.instant('gestion.reportes.planEs.textoMatrizFodaLargo') + ' ',
                  `${this.perspectivas.length} perspectivas: ${this.obtenerNombresPerspectivas().toLocaleLowerCase()} `,
                  this.translateService.instant('gestion.reportes.planEs.bajoMetodologia'),
                ],
                alignment: 'justify',
                margin: [45, 15, 0, 0],
                color: '#808080',
                fontSize: 11,
              },
              {
                image: this.imgFloa,
                width: 400,
                alignment: 'center',
                margin: [45, 30, 0, 0],
              },
              {
                text: [
                  this.translateService.instant('gestion.reportes.planEs.textoMatrizFodaInstituto') + ' ' + `${this.nombreInstitucion.nombre}` + this.translateService.instant('gestion.reportes.planEs.textoMatrizFodaResultado'),
                ],
                alignment: 'justify',
                margin: [45, 30, 0, 0],
                color: '#808080',
                fontSize: 11,
              },
              { text: '', pageBreak: 'after' },
              {
                text: this.translateService.instant('gestion.reportes.planEs.matrizFodaTitulo'),
                style: 'header',
                fontSize: 24,
                color: '#0455B2',
                alignment: 'left',
                bold: true,
              },
              {
                text: this.translateService.instant('gestion.reportes.planEs.corporativa'),
                style: 'header',
                fontSize: 18,
                color: '#ACBD3D',
                margin: [25, 0, 0, 0],
              },
              {
                table: tableFoda,
                layout: {
                  hLineColor: function (i) {
                    return '#8190B1';
                  },
                  vLineColor: function (i, node) {
                    return '#8190B1';
                  },
                },
              },
            ]
            : null,

          this.imprimirFodaV2
            ? [
              { text: '', pageBreak: 'after' },

              {
                text: this.translateService.instant('gestion.reportes.planEs.matrizRiesgosTitulo'),
                style: 'header',
                fontSize: 24,
                color: '#0455B2',
                alignment: 'left',
                bold: true,
              },
              {
                text: this.translateService.instant('gestion.reportes.planEs.corporativa'),
                style: 'header',
                fontSize: 18,
                color: '#ACBD3D',
                margin: [25, 0, 0, 0],
              },
              {
                table: tableFodaV2,
                layout: {
                  hLineColor: function (i) {
                    return '#8190B1';
                  },
                  vLineColor: function (i, node) {
                    return '#8190B1';
                  },
                },
              },
            ]
            : null,

          this.imprimirObjetivos
            ? [
              { text: '', pageBreak: 'after' },
              {
                text: this.translateService.instant('gestion.reportes.planEs.objetivosEstrategicosTitulo'),
                style: 'header',
                fontSize: 24,
                color: '#0455B2',
                // absolutePosition: { x: 50, y: 40 },/
                margin: [15, 0, 0, 0],
                alignment: 'left',
                bold: true,
              },
              {
                text: this.translateService.instant('gestion.reportes.planEs.definicion'),
                style: 'header',
                fontSize: 18,
                color: '#ACBD3D',
                margin: [25, 0, 0, 0],
                alignment: 'left',
              },

              {
                text: [
                  this.translateService.instant('gestion.reportes.planEs.textoObjetivos') + '\n\n',
                ],
                alignment: 'justify',
                margin: [45, 15, 0, 0],
                color: '#808080',
                fontSize: 11,
              },
              {
                text: [
                  {
                    text: this.translateService.instant('gestion.reportes.planEs.perspectivas') + '\n',
                    // style: 'header',
                    fontSize: 16,
                    color: '#0455B2',
                    fillColor: '#FFFFFF',
                    colSpan: 2,
                    alignment: 'left',
                    border: [false, false, false, false],
                  },
                ],
                margin: [45, 15, 0, 0],
              },
              {
                table: tableObjEst,
                margin: [45, 15, 0, 0],
                layout: {
                  hLineColor: function (i) {
                    return '#E0E0E0';
                  },
                  vLineColor: function (i, node) {
                    return 'white';
                  },
                },
                markerColor: '#808080',
              },
            ]
            : null,

          this.imprimirIndicadores
            ? [
              { text: '', pageBreak: 'after' },
              {
                text: this.translateService.instant('gestion.reportes.planEs.indicadoresClaveDesempenoTitulo'),
                style: 'header',
                fontSize: 24,
                color: '#0455B2',
                // absolutePosition: { x: 50, y: 40 },/
                margin: [15, 0, 0, 0],
                alignment: 'left',
                bold: true,
              },
              {
                text: this.translateService.instant('gestion.reportes.planEs.indicadoresMetasPerspectiva'),
                style: 'header',
                fontSize: 18,
                color: '#ACBD3D',
                margin: [25, 0, 0, 0],
                alignment: 'left',
              },

              {
                text: this.translateService.instant('gestion.reportes.planEs.textoIndicadores') + '\n\n',
                alignment: 'justify',
                margin: [45, 15, 0, 0],
                color: '#808080',
                fontSize: 11,
              },
              {
                text: [
                  {
                    text: this.translateService.instant('gestion.reportes.planEs.perspectivas') + '\n',
                    // style: 'header',
                    fontSize: 16,
                    color: '#0455B2',
                    fillColor: '#FFFFFF',
                    colSpan: 2,
                    alignment: 'left',
                    border: [false, false, false, false],
                  },
                ],
                margin: [45, 15, 0, 0],
              },
              ...tableIndMetas,
            ]
            : null,

          this.imprimirCmi
            ? [
              { text: '', pageBreak: 'after', pageOrientation: 'portrait' },
              {
                text: this.translateService.instant('gestion.reportes.planEs.cuadroMandoIntegralTitulo2'),
                style: 'header',
                fontSize: 24,
                color: '#0455B2',
                margin: [15, 0, 0, 0],
                bold: true,

                // absolutePosition: { x: 50, y: 40 },
              },
              {
                table: cmi,
                margin: [45, 15, 0, 0],
                layout: 'noBorders',
              },
            ]
            : null,

          this.imprimirPlanOperativo
            ? [
              { text: '', pageBreak: 'after', pageOrientation: 'landscape' },
              {
                text: this.translateService.instant('gestion.reportes.planEs.planOperativoTitulo2'),
                style: 'header',
                fontSize: 24,
                color: '#0455B2',
                // absolutePosition: { x: 50, y: 40 },/
                margin: [15, 0, 0, 0],
                alignment: 'left',
                bold: true,
              },
              {
                text: this.translateService.instant('gestion.reportes.planEs.consolidadoProyectos'),
                style: 'header',
                fontSize: 18,
                color: '#ACBD3D',
                margin: [25, 0, 0, 0],
                alignment: 'left',
              },
              {
                text: [
                  {
                    text: this.translateService.instant('gestion.reportes.planEs.textoUltimaFase'),
                    color: '#808080',
                    fontSize: 11,
                  },
                ],
                margin: [45, 30, 0, 0],
              },
              {
                ul: [
                  {
                    text: this.translateService.instant('gestion.reportes.planEs.liderPlan'),
                    color: '#808080',
                    fontSize: 11,
                  },
                  // { text: 'Actividades relevantes', color: '#808080' },
                  { text: this.translateService.instant('gestion.reportes.planEs.fechaInicioPlan'), color: '#808080', fontSize: 11 },
                  // { text: 'Días para su desarrollo', color: '#808080' },
                  { text: this.translateService.instant('gestion.reportes.planEs.fechaFinPlan'), color: '#808080', fontSize: 11 },
                  {
                    text: this.translateService.instant('gestion.reportes.planEs.responsableActividad'),
                    color: '#808080',
                    fontSize: 11,
                  },
                ],
                markerColor: '#4E9AC7',
                margin: [45, 10, 0, 0],
              },
              {
                table: tableProyectosEstrategicos,
                layout: {
                  hLineColor: function (i) {
                    return '#E0E0E0';
                  },
                  vLineColor: function (i, node) {
                    return 'white';
                  },
                },
                margin: [45, 0, 0, 0],
              },
            ]
            : null,
        ],
      };
      pdfMake
        .createPdf(docDefinition)
        .download(
          `Reporte_Global_${this.aniosDisponiblesPE[0].name}_${this.aniosDisponiblesPE[this.aniosDisponiblesPE.length - 1].name
          }` + '.pdf'
        );
      this.reporteGeneradoExitosamente = true;
      setTimeout(() => {
        this.isDownloadingPdf = false;
      }, 2000);
    } catch (error) {
      this.reporteGeneradoExitosamente = false;
      Swal.close();
      Swal.fire({ title: this.translateService.instant('gestion.reportes.planEs.errorAlGenerarReporte'), timer: 15000 });
    }
  }
}
